export const quantityOfTripsPerRequest = 10;
export const defaultTripsPageNumber = 1;
